﻿import * as types from './mutation-types';
import orderService from '../../../api/creditAccount/orderService';
import paymentService from '../../../api/creditAccount/paymentService';
import creditCheckService from '../../../api/creditAccount/creditCheckService';
import documentManagerService from '../../../api/creditAccount/documentManagerService';

const VAT = 0.2;
const currency = "DKK";

export const hideLoader = ({ commit, state }) => {
    commit(types.HIDE_LOADER);
}

export const resetCreditAgreementItem = ({ commit, state }, data) => {
    commit(types.RESET_CREDIT_AGREEMENT_ITEM, data);
}
export const resetCreditAgreementItemByOrder = ({ commit, state }, data) => {
    commit(types.RESET_CREDIT_AGREEMENT_ITEM_BY_ORDER, data);
}
export const updateCreditAgreementTotals = ({ commit, state }) => {
    commit(types.UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS);
}

export const changeCreditAgreementSelected = ({ commit, state }) => {
    commit(types.CHANGE_CREDIT_AGREEMENT_SELECTED);
}

export const setSelectedCreditInstallments = ({ commit, state }, selection) => {
    commit(types.SET_SELECTED_CREDIT_INSTALLMENTS, selection);
}

export const setSelectedCreditInstallmentsByOrder = ({ commit, state }, selection) => {
    commit(types.SET_SELECTED_CREDIT_INSTALLMENTS_BY_ORDER, selection);
}

export const changePaymentByOrder = ({ commit, state }, selection) => {
    commit(types.CHANGE_PAYMENT_BY_ORDER, selection);
}

export const updateUpfrontPaymentByOrder = ({ commit, state }, payload) => {
    commit(types.CHANGE_UPFRONT_PAYMENT_BY_ORDER, payload);
}
export const changePaymentBy = ({ commit, state }, selection) => {
    commit(types.CHANGE_PAYMENT_BY, selection);
}

export const setCreditCheckValid = ({ commit, state }, value) => {
    commit(types.IS_CREDIT_CHECK_VALID, value);
}

export const changeUpfrontPayment = ({ commit, state }, selection) => {
    commit(types.CHANGE_UPFRONT_PAYMENT, selection);
}

export const setTexts = ({ commit, state }, texts) => {
    commit(types.SET_TEXTS, texts);
}

export const setConstants = ({ commit, state }, constants) => {
    commit(types.SET_CONSTANTS, constants);
}

export const setPageLoaderTexts = ({ commit, state }, loaderTexts) => {
    commit(types.SET_PAGE_LOADER_TEXTS, loaderTexts);
}

export const setButtonTexts = ({ commit, state }, texts) => {
    commit(types.SET_BUTTON_TEXTS, texts);
}

//PREAUTH & DOWNPAYMENT
export const getPreAuth = ({ commit, state }, loaderData) => {
    commit(types.GET_PREAUTH, loaderData);
    orderService.getPreAuth(
        state.order.orderId,
        state.order.orderer.identityData.nationalIdentificationNumber,
        currency,
        state.order.dealerCode,
        state.order.totalPrice * 100, //amount       
        "0", //vatAmount, //state.order.totalVatAmmount * 100,  
        "24", //paymentTerms
        state.order.orderer.identityData.physicalIdentificationMethodType, //authenticationType
        state.order.orderer.identityData.physicalIdentificationMethodValue, //authenticationRef
        state.order.salesAgent,//cashierRef
        (preAuth) => preAuthCallbackHandler(commit, state, preAuth),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'preAuthData', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['retryPreAuth', 'cancel'] }));
}

function preAuthCallbackHandler(commit, state, preAuth) {
    preAuth.Return.Response.CreditLimit /= 100;
    preAuth.Return.Response.AvailableAmount /= 100;
    preAuth.Return.Response.AvailableCreditLimits = preAuth.Return.Response.AvailableCreditLimits.map(function (item) { return item / 100; });

    commit(types.STORE_PREAUTH, preAuth);
    if (state.preAuth.blocked) {
        state.creditAgreement.subscriptionAgreementItems.forEach(function (item) {
            if (item.hardwarePaymentId > 0) {
                deleteHardwarePayment({ commit, state }, item);
            }
        })
    }
    else {
        if (!state.creditEvaluation.selectedCreditLimit) {
            const preAuthStatus = preAuth.Return.Status.TransactionStatus;

            var parameters = {
                'creditSteps': preAuth.Return.Response.AvailableCreditLimits,
                'lastRetrievalStatus': preAuthStatus
            };

            if (preAuthStatus === "0" || preAuthStatus === "8") {
                //EXISTING CUSTOMER OR EXISTING CUSTOMER WITH INSUFFICIENT FUNDS
                parameters.currentCreditLimitAmount = Number(preAuth.Return.Response.CreditLimit);
                parameters.currentCreditLimitVat = parameters.currentCreditLimitAmount * VAT;
                parameters.currentCreditLimitCurrency = currency;
                parameters.availableAmount = Number(preAuth.Return.Response.AvailableAmount);
                parameters.availableAmountVat = parameters.availableAmount * VAT;
                parameters.availableAmountCurrency = currency;
            }

            creditCheckService.setCreditCheckOptions(state.order.orderId, parameters);
        }

        orderService.updateOrder(state.order.orderId, 'creditPaymentConsent', true,
            (exception) => commit(types.SHOW_MODAL, { 'context': 'updateOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': ['saving the changes'], 'buttons': ['refresh'] }));
    }

    getDownPaymentPlan({ commit, state });
}

export const getJoiceCreditCheck = ({ commit, state }, loaderData) => {
    commit(types.GET_JOICE_CREDITCHECK, loaderData);
    orderService.getJoiceCreditCheck(
        state.order.orderId,
        state.order.totalPrice * 100, //amount       
        "0", //vatAmount, //state.order.totalVatAmmount * 100,
        //success callback
        (joiceCreditCheck) => {
            joiceCreditCheckCallbackHandler(commit, state, joiceCreditCheck);
        },
        //error Callback
        () => commit(types.SHOW_MODAL, { 'context': 'joiceCreditCheckData', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['retryJoiceCreditCheck', 'cancel'] }));
}

function joiceCreditCheckCallbackHandler(commit, state, joiceCreditCheck) {
    commit(types.STORE_JOICE_CREDITCHECK, joiceCreditCheck);
    if (state.joiceCreditCheck.status !== "APPROVED") {
        hardwarePaymentByOrder({ commit, state }, state.creditAgreement.subscriptionAgreementItems);
    }
    else {
        var parameters = {
            'creditSteps': joiceCreditCheck.Result.CreditAccountLimit //available credit limit amount
        };
        if (joiceCreditCheck.Result.TfAccountExists) {
            //EXISTING CUSTOMER OR EXISTING CUSTOMER WITH INSUFFICIENT FUNDS
            parameters.currentCreditLimitAmount = Number(joiceCreditCheck.Result.CreditAccountCurrentLimit);
            parameters.currentCreditLimitVat = Number(joiceCreditCheck.Result.CreditAccountCurrentLimit) * VAT;
            parameters.currentCreditLimitCurrency = currency;
            parameters.availableAmount = Number(joiceCreditCheck.Result.CreditAccountCurrentAvailableAmount);
            parameters.availableAmountVat = parameters.availableAmount * VAT;
            parameters.availableAmountCurrency = currency;
        }
        creditCheckService.setCreditCheckOptions(state.order.orderId, parameters);
        orderService.updateOrder(state.order.orderId, 'creditPaymentConsent', true,
            //error callback
            () => commit(types.SHOW_MODAL, { 'context': 'updateOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': ['saving the changes'], 'buttons': ['refresh'] }));
    }
}

export const getDownPaymentPlan = ({ commit, state }) => {
    orderService.getDownPaymentPlan(state.order.orderId,
        (downPaymentPlan) => commit(types.STORE_DOWN_PAYMENT_PLAN, downPaymentPlan),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'downPaymentPlan', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': ['getting the DownPaymentPlan'], 'buttons': ['refresh'] }));
}

//ORDER

export const getOrder = ({ commit, state }, data) => {
    commit(types.GET_ORDER, data);
    const errObj = { 'context': 'getOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] };
    orderService.getOrder(
        data.orderGuid,
        (order) => getOrderCallbackHandler(commit, state, order, data),
        (exception) => commit(types.SHOW_MODAL, errObj));
}

function getOrderCallbackHandler(commit, state, order, data) {
    commit(types.STORE_ORDER, order);

    if (!state.inErrorState) {
        if (data.context === 'payment') {
            if (data.useCashOnlyFlowFlag && !state.order.useNewDiva) {
                state.creditAgreement.subscriptionAgreementItems.forEach(function (item) {
                    if (item.hardwarePaymentId > 0) {
                        const resetData = {
                            'id': item.id,
                            'fullReset': 'yes'
                        };
                        resetCreditAgreementItem({ commit, state }, resetData)
                        deleteHardwarePayment({ commit, state }, item);
                    }
                })
            }
            else if (state.order.useNewDiva && state.order.manualSigning){
                resetCreditAgreementItemByOrder({ commit, state }, state.creditAgreement.subscriptionAgreementItems)
                hardwarePaymentByOrder({ commit, state }, state.creditAgreement.subscriptionAgreementItems);
            }

            getDiscountDetails({ commit, state });
            for (let i = 0; i < order.contractQuestions.length; i++) {
                if (order.contractQuestions[i].question === "TF_CREDIT_ACCOUNT_PAYMENT" && order.contractQuestions[i].answer === true) {
                    if (!state.order.useNewDiva) {
                        getPreAuth({ commit, state }, {
                            'loaderTitle': data.preAuthLoaderTitle,
                            'loaderMessage': data.preAuthLoaderMessage
                        });
                    }
                }
            }
        }

        if (data.context === 'summary') {
            let items = [];
            if (order.accountOrderItem.length > 0) {
                items = order.accountOrderItem[0].subscriptions;

                if (order.accountOrderItem[0].legalResponsibleEmail) {
                    validateEmail({ commit, state }, order.accountOrderItem[0].legalResponsibleEmail);
                }
            }
            else if (order.subscriptionOrderItem.length > 0) {
                items = order.subscriptionOrderItem;
            }
            items.forEach(function (item, index) {
                orderService.getPricePlanName(item.id, item.offeringCode,
                    (pricePlanData) => commit(types.STORE_PRICE_PLAN_NAME, pricePlanData));
                orderService.getDirectoryListingText(item.id, item.directoryListingLevel,
                    (directoryListingData) => commit(types.STORE_DIRECTORY_LISTING_TEXT, directoryListingData));

                if (item.customerConsents != null) {
                    if (item.customerConsents.length > 0) {
                        // Set consent titles
                        item.customerConsents.forEach(function (consent_item, index) {
                            orderService.getConsentData(
                                item.id,
                                "SUBSCRIPTION-ID",
                                "da-DK",
                                consent_item.consentId,
                                (consentData) => commit(types.STORE_CONSENT_TITLES, consentData));
                        });
                    }
                }

                if (item.additionalProducts != null) {
                    if (item.additionalProducts.additionalProduct.length > 0) {
                        item.additionalProducts.additionalProduct.forEach(function (ap_item, ap_index) {
                            orderService.getAdditionalProductName(item.id, ap_item.productCode,
                                (additionalProductData) => commit(types.STORE_ADDITIONAL_PRODUCT_NAME, additionalProductData));
                        })
                    }
                    if (item.additionalProducts.includedAdditionalProduct.length > 0) {
                        item.additionalProducts.includedAdditionalProduct.forEach(function (iap_item, iap_index) {
                            orderService.getAdditionalProductName(item.id, iap_item,
                                (includedAdditionalProductData) => commit(types.STORE_INCLUDED_ADDITIONAL_PRODUCT_NAME, includedAdditionalProductData));
                        })
                    }
                    if (item.additionalProducts.lostAdditionalProduct.length > 0) {
                        item.additionalProducts.lostAdditionalProduct.forEach(function (lap_item, lap_index) {
                            orderService.getAdditionalProductName(item.id, lap_item,
                                (lostAdditionalProductData) => commit(types.STORE_LOST_ADDITIONAL_PRODUCT_NAME, lostAdditionalProductData));
                        })
                    }
                }
            });

            if (!((order.accountOrderItem.length > 0 && order.accountOrderItem[0].legalResponsibleEmail != null && order.accountOrderItem[0].legalResponsibleEmail != "") || (order.billingAccountNumber == null || order.billingAccountNumber == ""))) {
                orderService.getLegalOwnerEmailFromCDS(order.orderId, order.dealerCode, order.channelType, order.salesAgent, order.billingAccountNumber,
                    (legalOwnerEmail) => legalOwnerEmailCallbackHandler(commit, state, legalOwnerEmail));
            }

            // Check if there are any contracts for given order
            documentManagerService.hasAnyContract(
                order.orderId,
                order.dealerCode,
                order.salesAgent,
                (anyContractCheckResponse) => commit(types.STORE_HAS_ANY_CONTRACT, anyContractCheckResponse),
                (exception) => commit(types.SHOW_MODAL, { 'context': 'hasAnyContract', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));

            // Check if there are any Telia contracts for given order
            documentManagerService.hasAnyTeliaContract(
                order.orderId,
                order.dealerCode,
                order.salesAgent,
                (teliaContractCheckResponse) => commit(types.STORE_HAS_ANY_TELIA_CONTRACT, teliaContractCheckResponse),
                (exception) => commit(types.SHOW_MODAL, { 'context': 'hasAnyTeliaContract', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));

            if (state.order.modifiableByCustomer) {
                documentManagerService.checkContractsSignature(
                    order.orderId,
                    order.dealerCode,
                    order.salesAgent,
                    (checkContractsSignature) => commit(types.STORE_CHECK_CONTRACTS, checkContractsSignature),
                    (exception) => commit(types.SHOW_MODAL, { 'context': 'checkSignature', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));
            } else {
                commit(types.SKIP_CHECK_CONTRACTS, !state.order.modifiableByCustomer);
            }
        }
    }
}

export const getDiscountDetails = ({ commit, state }) => {
    paymentService.getDiscountDetails(state.order.orderId, state.order.dealerCode,
        (discountsData) => commit(types.STORE_DISCOUNT_DETAILS, discountsData),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'getDiscountDetails', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': ['getting the discount details'], 'buttons': ['refresh'] }));
}

export const updateDiscountInHardwarePayment = ({ commit }, data) => {
    commit(types.SET_DISCOUNT, data);
}

export const updateDiscountByOrder = ({ commit }, data) => {
    commit(types.SET_DISCOUNT_BY_ORDER, data);
}

export const showCancelOrderDialog = ({ commit, state }) => {
    commit(types.SHOW_MODAL, { 'context': 'cancelOrder', 'errorState': false, 'icon': 'norlysred', 'showHeadline': false, 'messageContent': [], 'buttons': ['cancel', 'close'] });
}

export const showManualSigningDialog = ({ commit, state }, texts) => {
    commit(types.SHOW_MODAL_MANUAL_SIGNING, texts);
}

export const showDigitalSigningDialog = ({ commit, state }, texts) => {
    commit(types.SHOW_MODAL_DIGITAL_SIGNING, texts);
}

export const showInstallmentsNotSetDialog = ({ commit, state }) => {
    commit(types.SHOW_MODAL, { 'context': 'installmentsNotSet', 'errorState': false, 'icon': 'norlysred', 'showHeadline': false, 'messageContent': [], 'buttons': ['close'] });
}

export const cancelOrder = ({ commit, state }, tangourl) => {
    orderService.cancelOrder(state.order.orderId, state.order.dealerCode, state.order.channelType,
        (cancelOrderData) => cancelOrderCallbackHandler(cancelOrderData, tangourl),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'cancelOrderError', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));
}

function cancelOrderCallbackHandler(cancelOrderData, tangourl) {
    if (!cancelOrderData.IsInErrorState) {
        window.location = tangourl;
    }
    else {
        commit(types.SHOW_MODAL, { 'context': 'cancelOrderError', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] });
    }
}

export const updateOrder = ({ commit, state }, data) => {
    orderService.updateOrder(state.order.orderId, data.context, data.answer,
        (exception) => commit(types.SHOW_MODAL, { 'context': 'updateOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': ['saving the changes'], 'buttons': ['refresh'] }));
}

//CREDIT CHECK
export const setCreditCheckNewCreditLimit = ({ commit, state }, credit) => {
    var loaderData = {
        'loaderTitle': state.pageLoader.loaderSetCreditCheckNewCreditLimitLoaderTitle,
        'loaderMessage': state.pageLoader.loaderSetCreditCheckNewCreditLimitLoaderMessage
    };
    commit(types.GET_SELECTED_CREDIT_LIMIT, loaderData);

    creditCheckService.setCreditCheckNewCreditLimit(state.order.orderId, credit.amount, credit.vat, credit.currency,
        (creditLimit) => commit(types.STORE_SELECTED_CREDIT_LIMIT, creditLimit),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'updateOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': ['updating the credit limit'], 'buttons': ['refresh'] }));
}

export const resetCreditLimit = ({ commit, state }, redirectUrl) => {
    var loaderData = {
        'loaderTitle': state.pageLoader.loaderResetCreditCheckNewCreditLimitLoaderTitle,
        'loaderMessage': state.pageLoader.loaderResetCreditCheckNewCreditLimitLoaderMessage
    };
    commit(types.GET_RESET_CREDIT_LIMIT, loaderData);

    creditCheckService.setCreditCheckNewCreditLimit(state.order.orderId, 0, 0, "DKK",
        (creditLimit) => commit(types.RESET_CREDIT_LIMIT, redirectUrl),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'updateOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': ['updating the credit limit'], 'buttons': ['refresh'] }));
}

export const externalCreditCheck = ({ commit, state }, loaderData) => {
    commit(types.GET_CREDIT_CHECK_RESULT, loaderData);

    var parameters = externalCreditCheckParameters(state);
    creditCheckService.externalCreditCheck(
        state.order.orderId,
        parameters,
        (externalCreditCheckResult) => externalCreditCheckCallbackHandler(commit, state, externalCreditCheckResult),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'creditCheck', 'errorState': false, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['retryCreditCheck', 'close'] }));
}

function externalCreditCheckCallbackHandler(commit, state, externalCreditCheckResult) {
    commit(types.STORE_CREDIT_CHECK_RESULT, externalCreditCheckResult);
    var externalCreditCheckResultObject = JSON.parse(externalCreditCheckResult);

    var param = creditCheckResultParameters(externalCreditCheckResultObject);
    var creditTermsString = JSON.stringify(externalCreditCheckResultObject.CreditTerms);

    if (externalCreditCheckResultObject.Decision === "OK") {
        creditCheckService.setCreditCheckResult(
            state.order.orderId,
            creditTermsString,
            param,
            (setCreditCheckResult) => commit(types.SET_CREDIT_CHECK_RESULT, setCreditCheckResult),
            (exception) => commit(types.SHOW_MODAL, { 'context': 'creditCheck', 'errorState': false, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['retryCreditCheck', 'close'] })
        );
    }
}

function externalCreditCheckParameters(state) {
    return {
        'clientAnnotation.clientId': 'epipm',
        'clientAnnotation.uniqueProcessCallId': '123',
        'dealerCode': state.order.dealerCode,
        'userId': state.order.salesAgent
    }
}

function creditCheckResultParameters(externalCreditCheckResultObject) {
    return {
        'Reference': externalCreditCheckResultObject.Reference,
        'Decision': externalCreditCheckResultObject.Decision,
        'ApprovedCreditLimit.Currency': externalCreditCheckResultObject.ApprovedCreditLimit.Currency,
        'ApprovedCreditLimit.VAT': externalCreditCheckResultObject.ApprovedCreditLimit.VAT,
        'ApprovedCreditLimit.Amount': externalCreditCheckResultObject.ApprovedCreditLimit.Amount,
        'StatusCode': externalCreditCheckResultObject.StatusCode,
        'CreditTerms': externalCreditCheckResultObject.CreditTerms,
        'Code': externalCreditCheckResultObject.Code
    }
}

//PBS INFORMATION
export const updatePBSInformation = ({ commit, state }, pbsData) => {
    commit(types.UPDATE_PBS_INFORMATION, pbsData);
    orderService.logPBSInfo(state.order.orderId, pbsData.field, pbsData.value);
}

export const setPBSInfoError = ({ commit, state }, validationStatus) => {
    commit(types.SET_PBS_ERROR, validationStatus);
}

//HARDWARE PAYMENT
export const createHardwarePayment = ({ commit, state }, subscriptionAgreementItem) => {
    var parameters = createHardwarePaymentParameters(state, subscriptionAgreementItem);

    paymentService.createHardwarePaymentAsync(parameters,
        (externalcreditcheck) => commit(types.STORE_HARDWARE_PAYMENT, externalcreditcheck),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'updateOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': ['creating a hardware payment'], 'buttons': ['refresh'] }));
}

export const updateHardwarePayment = ({ commit, state }, subscriptionAgreementItem) => {
    var loaderData = {
        'loaderTitle': state.pageLoader.loaderUpdateHardwarePaymentLoaderTitle,
        'loaderMessage': state.pageLoader.loaderUpdateHardwarePaymentLoaderMessage
    };

    commit(types.GET_UPDATE_HARDWARE_PAYMENT, loaderData);

    var parameters = createHardwarePaymentParameters(state, subscriptionAgreementItem);

    paymentService.updateHardwarePaymentAsync(parameters,
        (hardwarePayment) => commit(types.STORE_UPDATE_HARDWARE_PAYMENT, hardwarePayment),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'updateOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': ['updating a hardware payment'], 'buttons': ['refresh'] }));
}

export const deleteHardwarePayment = ({ commit, state }, subscriptionAgreementItem) => {
    let orderId = state.order.orderId;
    let subscriptionId = subscriptionAgreementItem.id;
    let hardwarePaymentId = subscriptionAgreementItem.hardwarePaymentId;

    paymentService.deleteHardwarePaymentAsync(orderId, subscriptionId, hardwarePaymentId,
        (subscriptionId) => commit(types.DELETE_HARDWARE_PAYMENT, subscriptionId),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'updateOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': ['deleting a hardware payment'], 'buttons': ['refresh'] }));
}

export const hardwarePaymentByOrder = ({ commit, state }, subscriptionAgreementItems) => {
    const parameters = hardwarePaymentParametersPerOrder(state, subscriptionAgreementItems);
    paymentService.hardwarePaymentByOrderAsync(parameters,
        //Success callback
        (externalcreditcheck) => commit(types.STORE_HARDWARE_PAYMENT, externalcreditcheck),
        //error callback
        () => commit(types.SHOW_MODAL, { 'context': 'updateOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': ['creating a hardware payment'], 'buttons': ['refresh'] }));
}

function createHardwarePaymentParameters(state, subscriptionAgreementItem) {
    let downPaymentInstallmentAmount = Number(subscriptionAgreementItem.monthlyPayment);
    let downPaymentLastInstallmentAmount = Number(subscriptionAgreementItem.lastInstallment);
    let downPaymentNumberOfInstallments = Number(subscriptionAgreementItem.numberOfInstallments);
    let downPaymentAmount = (downPaymentNumberOfInstallments > 0) ? ((downPaymentNumberOfInstallments - 1) * downPaymentInstallmentAmount) + Number(subscriptionAgreementItem.lastInstallment) : 0;
    let discountAmount = getTotalDiscountPerSubscription(subscriptionAgreementItem); // Number(subscriptionAgreementItem.discount);   
    let totalPaymentAmount = getTotalPricePerSubscription(subscriptionAgreementItem) - discountAmount; // Number(subscriptionAgreementItem.price) - Number(subscriptionAgreementItem.discount);
    let upFrontPaymentAmount = Number(subscriptionAgreementItem.upfrontPayment);

    var params = {
        'orderId': state.order.orderId,
        'subscriptionId': subscriptionAgreementItem.id,
        'hardwarePaymentId': subscriptionAgreementItem.hardwarePaymentId,
        'currency': currency,
        'dealerCode': state.order.dealerCode,
        'discount': discountAmount,
        'discounts': subscriptionAgreementItem.discounts,
        'downPaymentAmount': downPaymentAmount,
        'downPaymentVAT': Number((downPaymentAmount * VAT).toFixed(2)),
        'downPaymentInstallmentAmount': downPaymentInstallmentAmount,
        'downPaymentInstallmentVAT': Number((downPaymentInstallmentAmount * VAT).toFixed(2)),
        'downPaymentLastInstallmentAmount': downPaymentLastInstallmentAmount,
        'downPaymentLastInstallmentVAT': Number((downPaymentLastInstallmentAmount * VAT).toFixed(2)),
        'downPaymentNumberOfInstallments': downPaymentNumberOfInstallments,
        'paymentType': subscriptionAgreementItem.paymentType,
        'totalPaymentAmount': totalPaymentAmount,
        'totalPaymentVAT': Number((totalPaymentAmount * VAT).toFixed(2)),
        'upFrontPaymentAmount': upFrontPaymentAmount,
        'upFrontPaymentVAT': Number((upFrontPaymentAmount * VAT).toFixed(2)),
        'downPaymentId': state.downPaymentPlan.plans[0].id
    };

    return params;
}

function hardwarePaymentParametersPerOrder(state, subscriptionAgreementItems) {
    let downPaymentNumberOfInstallments = Number(state.creditAgreement.numberOfInstallments);
    let downPaymentInstallmentAmount = Number(state.creditAgreement.monthlyPayment);
    let downPaymentLastInstallmentAmount = Number(state.creditAgreement.lastInstallment);
    let discountAmount = 0;
    let totalPaymentAmount = 0;
    for (let item = 0; item < subscriptionAgreementItems.length; item++) {

        totalPaymentAmount += getTotalPricePerSubscription(subscriptionAgreementItems[item]);
    }
    discountAmount = state.order.discount;
    let upFrontPaymentAmount = Number(state.creditAgreement.upfrontAmount);
    let downPaymentAmount = (downPaymentNumberOfInstallments > 0)
        ? ((downPaymentNumberOfInstallments - 1) * downPaymentInstallmentAmount) + Number(downPaymentLastInstallmentAmount) : 0;
    if (state.order.paymentBy.toLowerCase() === "cash" || state.order.manualSigning) {
        downPaymentAmount = 0;
        upFrontPaymentAmount = totalPaymentAmount - discountAmount;
        downPaymentNumberOfInstallments = 0;
    }
    totalPaymentAmount = downPaymentAmount + upFrontPaymentAmount;
    let discountVat = VAT * discountAmount;

    const params = {
        'orderId': state.order.orderId,
        'currency': currency,
        'downPaymentAmount': downPaymentAmount,
        'downPaymentVAT': Number((downPaymentAmount * VAT).toFixed(2)),
        'downPaymentNumberOfInstallments': downPaymentNumberOfInstallments,
        'dealerCode': state.order.dealerCode,
        'totalPaymentAmount': totalPaymentAmount,
        'totalPaymentVAT': Number((totalPaymentAmount * VAT).toFixed(2)),
        'upFrontPaymentAmount': upFrontPaymentAmount,
        'upFrontPaymentVAT': Number((upFrontPaymentAmount * VAT).toFixed(2)),
        'discountAmount': discountAmount,
        'discountVat': discountVat,
        'paymentType': subscriptionAgreementItems[0].paymentType,
    };
    return params;
}

function getTotalPricePerSubscription(subscriptionAgreementItem) {
    let sum = 0;

    for (let i = 0; i < subscriptionAgreementItem.hardwareItems.length; i++) {
        sum += subscriptionAgreementItem.hardwareItems[i].price;
    }

    return sum;
}

function getTotalDiscountPerSubscription(subscriptionAgreementItem) {
    let sum = 0;

    for (let i = 0; i < subscriptionAgreementItem.hardwareItems.length; i++) {
        sum += subscriptionAgreementItem.hardwareItems[i].discount;
    }

    return sum;
}

export const createExternalPayment = ({ commit, state }, data) => {
    var loaderData = {
        'loaderTitle': data.getCreateExternalPaymentLoaderTitle,
        'loaderMessage': data.getCreateExternalPaymentLoaderMessage
    };

    commit(types.GET_CREATE_EXTERNAL_PAYMENT, loaderData);

    paymentService.createExternalPayment(
        state.order.orderId,
        createExternalPaymentParameters(state),
        (createExternalPaymentData) => commit(types.SET_CREATE_EXTERNAL_PAYMENT, { 'status': JSON.parse(createExternalPaymentData), 'redirectUrl': data.redirectUrl }),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'createExternalPayment', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));
}

function createExternalPaymentParameters(state) {
    return {
        pbsData: JSON.stringify(state.pbsInformation)
    };
}

export const getTeliaContracts = ({ commit, state }, data) => {
    commit(types.GET_TELIA_CONTRACTS);
    documentManagerService.getTeliaContracts(
        data.orderId,
        data.dealerCode,
        data.userId,
        (teliaContracts) => commit(types.STORE_TELIA_CONTRACTS, teliaContracts),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'contracts', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));
}

export const getTFContracts = ({ commit, state }, data) => {
    commit(types.GET_TF_CONTRACTS);
    documentManagerService.getTFContracts(
        data.orderId,
        data.dealerCode,
        data.userId,
        (tfContracts) => commit(types.STORE_TF_CONTRACTS, tfContracts),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'contracts', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));
}

export const acceptCTC = ({ commit, state }, acceptCTC) => {
    commit(types.ACCEPT_CTC, acceptCTC);
}

export const acceptCTFC = ({ commit, state }, acceptCTFC) => {
    commit(types.ACCEPT_CTFC, acceptCTFC);
}

export const setSelectedSigner = ({ commit, state }, signerName) => {
    commit(types.SET_SELECTED_SIGNER, signerName);
}
export const checkPaymentPage = ({ commit, state }, checkPaymentPage) => {
    commit(types.IS_PAYMENT_PAGE, checkPaymentPage);
}

export const updateContractData = ({ commit, state }, contractData) => {
    commit(types.UPDATE_CONTRACT_DATA, contractData);
}

export const getLegalOwnerEmailFromCDS = ({ commit, state }, data) => {
    commit(types.GET_LO_EMAIL);
    orderService.getLegalOwnerEmailFromCDS(
        data.orderId,
        data.dealerCode,
        data.channelType,
        data.userId,
        data.ban,
        (legalOwnerEmail) => legalOwnerEmailCallbackHandler(commit, state, legalOwnerEmail));
}

function legalOwnerEmailCallbackHandler(commit, state, legalOwnerEmail) {
    validateEmail({ state, commit }, legalOwnerEmail);
    commit(types.STORE_LO_EMAIL, legalOwnerEmail);
}

export const validateEmail = ({ commit, state }, email) => {
    let emailIsValid = false;
    var chrbeforAt = email.substr(0, email.indexOf('@'));
    if (!(email.trim().length > 127)) {
        if (chrbeforAt.length >= 2) {
            var re = /^(([^<>()[\]{}'^?\\.,!|//#%*-+=&;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            emailIsValid = re.test(email);
        }
    }
    commit(types.SET_CUSTOMER_EMAIL_WARNING, !emailIsValid);
}

export const signContracts = ({ commit, state }, data) => {
    commit(types.GET_SIGN_CONTRACTS, { 'loaderTitle': data.loaderTitle, 'loaderMessage': data.loaderMessage });
    documentManagerService.signContracts(
        data.orderId,
        data.dealerCode,
        data.channelType,
        data.userId,
        data.signatureString,
        (signContracts) => signContractsCallbackHandler(commit, state, signContracts),
        (exception) => commit(types.SHOW_MODAL_REPEAT_SIGNING, { headline: "Problems while signing", message: "Click the button to repeat the signing.", 'signLoaderTitle': data.loaderTitle, 'signLoaderMessage': data.loaderMessage }));
}

function signContractsCallbackHandler(commit, state, signContracts) {
    commit(types.STORE_SIGN_CONTRACTS, signContracts);

    let parameters = createSubmitOrderParameters(state);
    orderService.submitOrder(state.order.orderId, parameters,
        (orderSubmitData) => commit(types.ORDER_SUBMITTED, orderSubmitData),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'submitOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));
}

export const signContractsByName = ({ commit, state }, data) => {
    commit(types.GET_SIGN_CONTRACTS_BY_NAME, { 'loaderTitle': data.loaderTitle, 'loaderMessage': data.loaderMessage });
    documentManagerService.signContractsByName(
        data.orderId,
        data.dealerCode,
        data.channelType,
        data.userId,
        data.signatureString,
        data.signer,
        (signContractsByName) => signContractsByNameCallbackHandler(commit, state, signContractsByName, state.digitalSigningModal.signatureLeft),
        (exception) => commit(types.SHOW_MODAL_REPEAT_SIGNING_BY_NAME, { headline: "Problems while signing", message: "Click the button to repeat the signing.", 'signLoaderTitle': data.loaderTitle, 'signLoaderMessage': data.loaderMessage }));
}

function signContractsByNameCallbackHandler(commit, state, signContractsByName, signatureLeft) {
    commit(types.STORE_SIGN_CONTRACTS_BY_NAME, signContractsByName);

    if (signatureLeft == 1) {
        let parameters = createSubmitOrderParameters(state);
        orderService.submitOrder(state.order.orderId, parameters,
            (orderSubmitData) => commit(types.ORDER_SUBMITTED, orderSubmitData),
            (exception) => commit(types.SHOW_MODAL, { 'context': 'submitOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));

    }
}

export const submitOrder = ({ commit, state }) => {
    let parameters = createSubmitOrderParameters(state);
    orderService.submitOrder(state.order.orderId, parameters,
        (orderSubmitData) => commit(types.ORDER_SUBMITTED, orderSubmitData),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'submitOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));
}

function createSubmitOrderParameters(state) {
    let creditAgreementItems = [];

    //TODO: Is this ok?
    for (let i = 0; i < state.creditAgreement.subscriptionAgreementItems.length; i++) {
        let subscriptionAgreementItem = state.creditAgreement.subscriptionAgreementItems[i];

        for (let h = 0; h < subscriptionAgreementItem.hardwareItems.length; h++) {
            let hardwareItem = subscriptionAgreementItem.hardwareItems[h];

            let creditAgreementItem = {
                equipmentName: hardwareItem.equipmentName,
                subscriptionId: subscriptionAgreementItem.id,
                hardwarePaymentId: subscriptionAgreementItem.hardwarePaymentId,
                numberOfInstallments: subscriptionAgreementItem.numberOfInstallments,
                monthlyPayment: {
                    amount: subscriptionAgreementItem.monthlyPayment,
                    vat: subscriptionAgreementItem.monthlyPayment * VAT,
                    currency: "DKK"
                },
                lastInstallment: {
                    amount: subscriptionAgreementItem.lastInstallment,
                    vat: subscriptionAgreementItem.lastInstallment * VAT,
                    currency: "DKK"
                },
                price: {
                    amount: hardwareItem.price - hardwareItem.discount,
                    vat: (hardwareItem.price - hardwareItem.discount) * VAT,
                    currency: "DKK"
                },
                upfrontPayment: {
                    amount: subscriptionAgreementItem.upfrontPayment,
                    vat: subscriptionAgreementItem.upfrontPayment * VAT,
                    currency: "DKK"
                },
                downPayment: {
                    amount: Number(hardwareItem.price), // - subscriptionAgreementItem.upfrontPayment),
                    vat: Number(hardwareItem.price) * VAT, // - subscriptionAgreementItem.upfrontPayment) * VAT,
                    currency: "DKK"
                },
                paymentBy: subscriptionAgreementItem.paymentBy,
                paymentType: subscriptionAgreementItem.paymentType,
                phoneNumber: subscriptionAgreementItem.phoneNumber,
                materialId: hardwareItem.materialId,
                externalTransactionId: subscriptionAgreementItem.externalTransactionId
            };

            creditAgreementItems.push(creditAgreementItem);
        }
    }

    return {
        totalOnCredit: state.creditAgreement.totalCredit,
        creditCheckRef: state.creditEvaluation.creditCheckResult.creditCheckRef,
        creditagreementItems: JSON.stringify(creditAgreementItems),
        customerEmail: state.contracts.customerEmail,
        orderMemo: state.contracts.additionalInformation,
        approved: state.contracts.validEmails
    };
}

export const submitOrderForRemoteChannel = ({ commit, state }) => {
    let parameters = createSubmitOrderForRemoteChannelParameters(state);
    orderService.submitOrderForRemoteChannel(state.order.orderId, parameters,
        (orderSubmitForRemoteChannelData) => commit(types.ORDER_SUBMITTED_REMOTE_CHANNEL, orderSubmitForRemoteChannelData),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'submitOrder', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));
}

function createSubmitOrderForRemoteChannelParameters(state) {
    return {
        orderGuid: state.order.orderGuid,
        dealerCode: state.order.dealerCode,
        channelType: state.order.channelType,
        customerEmail: state.contracts.customerEmail,
        orderMemo: state.contracts.additionalInformation,
        approved: state.contracts.validEmails
    };
}


export const hideModal = ({ commit, state }) => {
    commit(types.HIDE_MODAL);
}
export const deactivateModal = ({ commit, state }) => {
    commit(types.DEACTIVATE_MODAL);
}
export const hidePopupMessage = ({ commit, state }) => {
    commit(types.HIDE_POPUP_MESSAGE);
}